/**
 * Vision 2040 Translations Module (Japanese)
 * @module vision2040
 * @language ja
 */

export const vision2040 = {
  vision2040Hero: {
    membersTarget: "会員目標",
    countryTarget: "国目標",
    annualBeneficiaries: "年間受益者"
  },
  vision2040TechTargets: {
    aiUsers: "400K+ユーザー",
    vrTrainers: "10K+トレーナー",
    appDownloads: "300K+ダウンロード",
    sustainabilityCountries: "80カ国"
  },
  strategicPillarsData: {
    expandTraining: "リーダーシップトレーニングプログラムの拡大",
    certifiedTrainers: "10,000人の認定トレーナー",
    goldStandard: "ゴールドスタンダードカリキュラム",
    trainingTarget: "2040年までに年間10万人トレーニング",
    expandDetail1: "JCIアカデミーを130カ国以上に拡大",
    expandDetail2: "グローバルに1万人の認定トレーナーを開発",
    expandDetail3: "多言語トレーニングプラットフォームを開始",
    expandDetail4: "業界別リーダーシップトラックを作成",
    expandDetail5: "大学とのパートナーシップを確立",
    trainedYear: "年間トレーニング",
    aiDashboard: "AIダッシュボード",
    offlineApp: "オフラインファーストモバイルアプリ",
    impactTracking: "リアルタイムインパクトトラッキング",
    techTarget: "2040年までに80%デジタル採用",
    techDetail1: "AI会員体験プラットフォームを展開",
    techDetail2: "VRリーダーシップシミュレーションプログラムを開始",
    techDetail3: "統一グローバルデータダッシュボードを作成",
    techDetail4: "ブロックチェーンインパクト検証を実装",
    techDetail5: "アクセシブルなモバイルファーストプラットフォームを構築",
    users: "ユーザー",
    climateAction: "気候行動統合",
    carbonNeutral: "カーボンニュートラル運営",
    renewableEnergy: "100%再生可能エネルギー",
    sustainabilityTarget: "2030年までにネットゼロ",
    sustainDetail1: "2030年までにカーボンニュートラル運営を達成",
    sustainDetail2: "すべてのプロジェクトにSDGマッピングを統合",
    sustainDetail3: "グリーン認証プログラムを作成",
    sustainDetail4: "環境組織とのパートナーシップ",
    sustainDetail5: "気候リテラシーカリキュラムを開発",
    riseProjects: "RISEプロジェクト",
    genderParity: "ジェンダーパリティの達成",
    expandUnderrepresented: "代表されていない地域への拡大",
    financialAccess: "金融アクセスプログラム",
    equityTarget: "2035年までに50%ジェンダーパリティ",
    equityDetail1: "リーダーシップで50%ジェンダーパリティを達成",
    equityDetail2: "サービスが行き届いていない地域でのプレゼンスを拡大",
    equityDetail3: "アクセスのための奨学金プログラムを作成",
    equityDetail4: "包括的なリーダーシップフレームワークを開発",
    equityDetail5: "アクセシビリティインフラストラクチャを構築"
  },
  simulator: {
    factors: {
      conservativeGrowth: "年間2-3%の会員成長",
      limitedDigital: "限定的なデジタルプラットフォーム採用",
      minimalPartnerships: "最小限の新規企業パートナーシップ",
      regionalChallenges: "地域拡大の課題",
      moderateGrowth: "年間5-7%の会員成長",
      fullDigital: "完全なデジタルプラットフォーム展開",
      strategicPartnerships: "戦略的企業パートナーシップ",
      regionalExpansion: "調整された地域拡大",
      aggressiveGrowth: "年間10-15%の会員成長",
      aiEngagement: "AIによる会員エンゲージメント",
      youthMovement: "若者運動のバイラル拡大",
      corporateSponsors: "大企業スポンサー"
    },
    risks: {
      targetsMissed: "ビジョン2040目標が達成されない可能性",
      reducedInfluence: "グローバルな影響力とリーチの低下",
      talentGaps: "サービスが行き届いていない地域での人材ギャップ",
      sustainedInvestment: "継続的な投資が必要",
      techInfrastructure: "技術インフラが必要",
      regionalLeadership: "強力な地域リーダーシップが必要",
      strainResources: "リソースが逼迫する可能性",
      qualityQuantity: "質と量のバランス",
      governanceChallenges: "ガバナンスの課題"
    }
  },
  vision2040: {
    title: "JCIビジョン2040",
    pageSubtitle: "50万人の若いリーダーへの戦略的ロードマップ",
    transformingFuture: "若いリーダーシップの未来を変革する",
    followProgress: "2040年までに持続可能なポジティブインパクトを創造する50万人の若いリーダーのグローバルネットワークに向けた進捗をフォロー。",
    exploreVision: "ビジョン2040を探索",
    
    // Tab Labels
    fiiImpact: "FIIインパクト",
    timeline: "タイムライン",
    simulator: "シミュレーター",
    globalView: "グローバルビュー",
    
    // FII Impact Section
    fiiImpactTitle: "2040年までのFIIインパクト",
    fiiImpactDesc: "JCIがビジョン2040戦略を実行した場合の予測されるFuture Investment Index改善",
    globalFIIPoints: "グローバルFIIポイント",
    africaMeFII: "アフリカ/中東FIIポイント",
    inequalityReduction: "不平等削減",
    regionalGapClosure: "地域ギャップ閉鎖",
    highest: "最高",
    mentalHealthPillar: "メンタルヘルス",
    workforceDevelopment: "労働力開発",
    entrepreneurshipPillar: "起業家精神",
    projectedReach: "予測リーチ",
    fiiImpactLabel: "FIIインパクト",
    primaryFocus: "主要フォーカス",
    regionalFIIProjectionsTitle: "地域FII予測：2025 vs 2040",
    current2025: "2025年現在",
    projected2040: "2040年予測",
    maintainLead: "リードを維持",
    strongGrowth: "強い成長",
    accelerating: "加速中",
    highestImprovement: "最高の改善",
    sourceFII: "出典：JCIビジョン2040戦略計画 | Future Investment Index 2024予測",
    
    // Simulator Section
    simulatorTitle: "ビジョン2040シナリオシミュレーター",
    simulatorSubtitle: "JCIの3つの可能な未来を探索。期待を超えた場合—または不足した場合は何が起こるか？",
    baseline2025: "ベースライン2025",
    conservative: "保守的",
    conservativeDesc: "成長が停滞したら？限定的なテック採用、最小限のパートナーシップ、経済的逆風。",
    moderate: "中程度（目標）",
    moderateDesc: "予想されるデジタル採用と戦略的パートナーシップを伴う計画された成長軌跡。",
    aggressive: "積極的",
    aggressiveDesc: "完全なテック採用、広範なパートナーシップ、バイラル拡大による最大成長。",
    probability: "確率",
    scenarioOutcomes: "シナリオ結果",
    vsTarget: "vs 目標",
    onTarget: "目標通り",
    keySuccessFactors: "主要成功要因",
    risksAndChallenges: "リスクと課題",
    growthTrajectory: "成長軌跡比較",
    scenario: "シナリオ",
    targetModerate: "目標（中程度）",
    comparisonSummary: "シナリオ比較サマリー",
    metric: "メトリック",
    baseline: "ベースライン",
    target2040: "2040年目標",
    sourceSimulator: "出典：JCIビジョン2040戦略計画 | シナリオは例示的予測です",
    
    // Growth Visualization Section
    growthVisualization: "成長の可視化",
    growthDesc: "2025年ベースラインから2040年目標への戦略的成長軌跡",
    growthVisualizationDesc: "2025年ベースラインから2040年目標への戦略的成長軌跡",
    progress: "進捗",
    members: "会員",
    membersK: "会員（K）",
    targetK: "目標（K）",
    countries: "国",
    localOrganizations: "ローカル組織",
    annualProjects: "年間プロジェクト",
    annualBeneficiaries: "年間受益者",
    current: "現在",
    target: "目標",
    growth: "成長",
    cagr: "年平均成長率",
    cagrMembers: "~8-10% CAGR",
    nationsGrowth: "+86カ国",
    expansionRegions: "サブサハラアフリカ、中東、東南アジア",
    moreGrassrootsHubs: "より多くの草の根拠点",
    projectOrgAverage: "~1プロジェクト/組織平均",
    youthPopulation: "~世界の若者人口の1.2%",
    priority: { critical: "重大", high: "高", medium: "中", low: "低" },
    globalPresence: "グローバルJCIプレゼンス",
    globalMembers: "グローバルメンバー",
    activeCountries: "アクティブ国",
    averageGrowth: "平均成長",
    regionalDistribution: "地域分布",
    globalPerformance: "グローバルパフォーマンス",
    performanceComparison: "現在のパフォーマンス vs ビジョン2040目標の比較",
    detailedAnalysis: "詳細な地域分析",
    featuredCountries: "注目国",
    achievements: "達成",
    challenges: "課題",
    mainInitiatives: "主要イニシアチブ",
    leadershipDevelopment: "リーダーシップ開発の卓越性",
    technologyInnovation: "テクノロジーとデジタルイノベーション",
    sustainabilityFocus: "サステナビリティとインパクトフォーカス",
    globalNetworkGrowth: "グローバルネットワーク拡大",
    strategicPillars: "戦略的ピラー",
    strategicPillarsTitle: "2040年への4つの戦略的ピラー",
    strategicPillarsSubtitle: "グローバルに若者の機会を変革する統合アプローチ",
    strategicPillarsDesc: "私たちのロードマップは、世界中の若者の機会を変革する4つの相互接続されたピラーに基づいています",
    viewAllInitiatives: "すべてのイニシアチブを表示",
    allInitiatives: "すべてのイニシアチブ",
    pillar1Title: "メンタルヘルスとウェルビーイング",
    pillar2Title: "労働力開発とスキル",
    pillar3Title: "起業家精神とイノベーション",
    pillar4Title: "グローバルパートナーシップとスケーリング",
    sustainability: "サステナビリティ",
    equityInclusion: "公平性と包摂",
    current2040Target: "現在 → 2040年目標",
    milestoneRoadmap: "マイルストーンロードマップ",
    milestoneDesc: "現在の状態からビジョン2040達成までの旅をトラック",
    currentState: "現在の状態",
    currentStateDesc: "出発点 - 114カ国で14.8万人の会員",
    midpointTarget: "中間目標",
    midpointTargetDesc: "中間点 - 150カ国で30万人の会員",
    accelerationPhase: "加速フェーズ",
    accelerationPhaseDesc: "急速なスケーリング - 175カ国で40万人の会員",
    visionAchieved: "ビジョン達成",
    visionAchievedDesc: "完全目標 - 200カ国で50万人の会員",
    inProgress: "進行中",
    upcoming: "予定",
    completed: "完了",
    planned: "計画済み",
    orgs: "組織",
    projects: "プロジェクト",
    beneficiaries: "受益者",
    keyInitiatives: "主要イニシアチブ",
    needed: "必要",
    growthRequired: "成長が必要",
    sourceStrategicPlan: "出典：JCIビジョン2040戦略計画",
    timelineTitle: "ビジョン2040タイムライン",
    yearsRemaining: "残り年数",
    historicalProgress: "歴史的進捗",
    jciFounded: "JCI設立",
    foundedDesc: "ミズーリ州セントルイスでJunior Chamber International設立",
    globalExpansion: "グローバル拡大",
    globalExpansionDesc: "世界100カ国以上に拡大",
    foundationYear: "基盤年",
    foundationYearDesc: "デジタル変革とRISEプログラムのスケーリング",
    programs: "プログラム",
    implementationProgress: "実装進捗",
    digitalPlatform: "デジタルプラットフォーム",
    techTarget: "目標：2040年までに会員の80%以上がデジタルプラットフォームを使用",
    aiIntegration: "AI統合",
    aiDesc: "パーソナライズされた会員体験とプログラム推奨",
    vrTraining: "VRリーダーシップトレーニング",
    vrTrainingDesc: "リーダーシップ開発のためのイマーシブシミュレーション",
    aiDashboard: "AIダッシュボード",
    aiDashboardDesc: "AI推奨によるパーソナライズされた会員体験",
    sustainabilityGoals: "サステナビリティ目標",
    carbonNeutral: "カーボンニュートラル運営",
    carbonNeutralDesc: "2030年までに100%カーボンオフセット",
    sdgAlignment: "SDGアラインメント",
    sdgDesc: "すべてのプログラムが国連持続可能な開発目標にマッピング",
    techRoadmap: "テクノロジーロードマップ",
    techRoadmapDesc: "2040年への道のりにおけるデジタル変革のマイルストーン",
    mobileApp: "モバイルアプリケーション",
    mobileAppDesc: "すべての会員向けオフラインファーストモバイル体験",
    sustainabilityTracking: "サステナビリティトラッキング",
    sustainabilityTrackingDesc: "リアルタイム環境インパクトモニタリング",
    complete: "完了"
  },
  vision2040Extended: {
    fiiImpactTab: "FIIインパクト",
    timeline: "タイムライン",
    simulator: "シミュレーター",
    globalView: "グローバルビュー",
    milestoneTitle: "2040年へのマイルストーンロードマップ",
    milestoneSubtitle: "4つの戦略的フェーズにわたる主要目標と進捗指標",
    milestoneRoadmap: "マイルストーンロードマップ",
    milestoneRoadmapDesc: "現在の状態からビジョン2040達成までの旅をトラック",
    currentState: "現在の状態",
    currentStateDesc: "出発点 - 115カ国で17.5万人の会員",
    midpointTarget: "中間目標",
    midpointTargetDesc: "中間点 - 130カ国で30万人の会員",
    accelerationPhase: "加速フェーズ",
    accelerationPhaseDesc: "急速なスケーリング - 140カ国で40万人の会員",
    visionAchieved: "ビジョン達成",
    visionAchievedDesc: "完全目標 - 150カ国で50万人の会員",
    inProgress: "進行中",
    upcoming: "予定",
    completed: "完了",
    planned: "計画済み",
    target: "目標",
    members: "会員",
    countries: "国",
    localOrganizations: "ローカル組織",
    orgs: "組織",
    projects: "プロジェクト",
    beneficiaries: "受益者",
    keyInitiatives: "主要イニシアチブ",
    current: "現在",
    needed: "必要",
    growthRequired: "成長が必要",
    sourceStrategicPlan: "出典：JCIビジョン2040戦略計画",
    fiiImpactTitle: "2040年までのFIIインパクト",
    fiiImpactDesc: "JCIがビジョン2040戦略を実行した場合の予測されるFuture Investment Index改善",
    globalFIIPoints: "グローバルFIIポイント",
    africaMeFII: "アフリカ/中東FIIポイント",
    inequalityReduction: "不平等削減",
    regionalGapClosure: "地域ギャップ閉鎖",
    highest: "最高",
    mentalHealthPillar: "メンタルヘルス",
    workforceDevelopment: "労働力開発",
    entrepreneurshipPillar: "起業家精神",
    projectedReach: "予測リーチ",
    fiiImpactLabel: "FIIインパクト",
    primaryFocus: "主要フォーカス",
    regionalFIIProjectionsTitle: "地域FII予測：2025 vs 2040",
    current2025: "2025年現在",
    projected2040: "2040年予測",
    maintainLead: "リードを維持",
    strongGrowth: "強い成長",
    accelerating: "加速中",
    highestImprovement: "最高の改善",
    sourceFII: "出典：JCIビジョン2040戦略計画 | Future Investment Index 2024予測",
    timelineTitle: "ビジョン2040タイムライン",
    timelineDesc: "2040年への旅における歴史的コンテキストと将来のマイルストーン",
    yearsRemaining: "残り年数",
    historicalProgress: "歴史的進捗",
    jciFounded: "JCI設立",
    foundedDesc: "Junior Chamber International設立",
    globalExpansion: "グローバル拡大",
    globalExpansionDesc: "世界100カ国以上に拡大",
    foundationYearDesc: "デジタル変革とRISEプログラムのスケーリング",
    programs: "プログラム",
    implementationProgress: "実装進捗",
    simulatorTitle: "ビジョン2040シナリオシミュレーター",
    simulatorSubtitle: "JCIの3つの可能な未来を探索。期待を超えた場合—または不足した場合は何が起こるか？",
    baseline2025: "ベースライン2025",
    conservative: "保守的",
    conservativeDesc: "成長が停滞したら？限定的なテック採用、最小限のパートナーシップ、経済的逆風。",
    moderate: "中程度（目標）",
    moderateDesc: "予想されるデジタル採用と戦略的パートナーシップを伴う計画された成長軌跡。",
    aggressive: "積極的",
    aggressiveDesc: "完全なテック採用、広範なパートナーシップ、バイラル拡大による最大成長。",
    probability: "確率",
    scenarioOutcomes: "シナリオ結果",
    annualProjects: "年間プロジェクト",
    vsTarget: "vs 目標",
    onTarget: "目標通り",
    keySuccessFactors: "主要成功要因",
    risksAndChallenges: "リスクと課題",
    growthTrajectory: "成長軌跡比較",
    scenario: "シナリオ",
    targetModerate: "目標（中程度）",
    comparisonSummary: "シナリオ比較サマリー",
    metric: "メトリック",
    baseline: "ベースライン",
    target2040: "2040年目標",
    sourceSimulator: "出典：JCIビジョン2040戦略計画 | シナリオは戦略計画目的の例示的予測です",
    simulatorData: {
      factors: {
        conservativeGrowth: "年間2-3%の会員成長",
        limitedDigital: "限定的なデジタルプラットフォーム採用",
        minimalPartnerships: "最小限の新規企業パートナーシップ",
        moderateGrowth: "年間5-7%の会員成長",
        fullDigital: "完全なデジタルプラットフォーム展開",
        strategicPartnerships: "戦略的企業パートナーシップ",
        aggressiveGrowth: "年間10-15%の会員成長",
        aiEngagement: "AIによる会員エンゲージメント",
        youthMovement: "若者運動のバイラル拡大"
      },
      risks: {
        targetsMissed: "ビジョン2040目標が達成されない可能性",
        reducedInfluence: "グローバルな影響力とリーチの低下",
        talentGaps: "サービスが行き届いていない地域での人材ギャップ",
        moderateRisk: "中程度の実行リスクが残る",
        resourceConstraints: "リソース制約の可能性",
        competitionRisk: "他組織との競争",
        executionChallenges: "重大な実行課題",
        fundingRequirements: "高い資金調達要件",
        marketChanges: "市場状況の変化の可能性"
      }
    },
    globalPresenceTitle: "JCIグローバルプレゼンス",
    globalMembers: "グローバルメンバー",
    activeCountries: "アクティブ国",
    averageGrowth: "平均成長",
    regionalDistribution: "地域分布",
    globalPerformance: "グローバルパフォーマンス",
    performanceComparison: "現在のパフォーマンス vs ビジョン2040目標の比較",
    detailedAnalysis: "詳細な地域分析",
    achievements: "達成",
    challenges: "課題",
    growth: "成長",
    priority: { critical: "重大", high: "高", medium: "中", low: "低" },
    milestoneInitiatives: {
      year2025: { initiative1: "デジタルプラットフォーム拡大", initiative2: "RISEプログラム継続", initiative3: "FIIベースライン確立", initiative4: "地域成長戦略" },
      year2030: { initiative1: "カーボンニュートラル運営", initiative2: "AIパワード会員ダッシュボード", initiative3: "50%ジェンダーパリティ達成", initiative4: "デジタルLMS完全展開" },
      year2035: { initiative1: "10,000人以上の認定トレーナー", initiative2: "VRリーダーシップトレーニング展開", initiative3: "アフリカ/中東FIIギャップ50%閉鎖", initiative4: "モバイルアプリ300K+ダウンロード" },
      year2040: { initiative1: "50万人の若いリーダーネットワーク", initiative2: "グローバルFII 4-7ポイント改善", initiative3: "80%以上のデジタルプラットフォーム採用", initiative4: "若者の機会を変革" }
    },
    pillarData: {
      mentalHealth: { current: "145のRISEプロジェクト", projection: "5,000以上のRISEプロジェクト", reach: "5000万人以上にリーチ", fiiImpact: "+2-3ポイント", focus: "アフリカ/中東のメンタルヘルスギャップ" },
      workforce: { current: "約5万人トレーニング済み", projection: "20万人以上の若者トレーニング", reach: "80%雇用率", fiiImpact: "+1-2ポイント", focus: "STEM/デジタルパスウェイ" },
      entrepreneurship: { current: "1K起業家", projection: "5万人以上サポート", reach: "5億ドル以上の資本動員", fiiImpact: "+1-2ポイント", focus: "10万人以上トレーニング" }
    },
    regionNames: { europe: "ヨーロッパ", asiaPacific: "アジアと太平洋", americas: "アメリカ", africaME: "アフリカ・中東" },
    radarSubjects: { leadership: "リーダーシップ", technology: "テクノロジー", sustainability: "サステナビリティ", partnerships: "パートナーシップ", innovation: "イノベーション", impact: "インパクト" },
    globalRegions: {
      americas: { name: "アメリカ", achievements: ["グローバル会員の8.0%", "強力なLOネットワーク"], challenges: ["会員継続", "地域多様性"] },
      europe: { name: "ヨーロッパ", achievements: ["グローバル会員の11.1%", "サステナビリティリーダーシップ"], challenges: ["高齢化人口統計", "成長停滞"] },
      asiaPacific: { name: "アジアと太平洋", achievements: ["グローバル会員の70.7%", "最高の成長ポテンシャル"], challenges: ["文化的障壁", "デジタルインフラ"] },
      africaME: { name: "アフリカ・中東", achievements: ["会員の10.3%", "若者人口の優位性"], challenges: ["限られたリソース", "接続性ギャップ"] }
    }
  }
} as const;
